export default "__VITE_ASSET__CHrVqvkR__"